export default __webpack_public_path__ + "static/media/MIA_BG_Horizontal.1bb1665e.svg";